const STORAGE_KEY = 'autodj.client_uid';

function generateUuid() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // RFC4122 v4 fallback (très improbable côté navigateur moderne)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Retourne (et persiste) un identifiant client unique stocké dans localStorage.
 * Utilisé pour empêcher le double-vote / double-bid sans login.
 */
export function getClientUid() {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const uid = generateUuid();
    localStorage.setItem(STORAGE_KEY, uid);
    return uid;
  } catch {
    // Mode privé / quota dépassé : on retombe sur un UID volatile par session
    return generateUuid();
  }
}
